import { render } from "./FruitCollectionPaginated.vue?vue&type=template&id=0b8343a2"
import script from "./FruitCollectionPaginated.vue?vue&type=script&lang=js"
export * from "./FruitCollectionPaginated.vue?vue&type=script&lang=js"

import "./FruitCollectionPaginated.vue?vue&type=style&index=0&id=0b8343a2&lang=css"
script.render = render

export default script